import { BackendError } from './base';
import General from './general';

class BankAccountDoesNotExist extends General.NotFound {}
class CannotDeactivateExternalAccount extends BackendError {}
class DepositIntentNotFound extends General.NotFound {}
class DictRequestNotFound extends General.NotFound {}
class ExternalAccountDoesNotExist extends General.NotFound {}
class InsufficientBalance extends BackendError {}
class DuplicatedBankingOperation extends BackendError {}
class LedgerEntryDoesNotExist extends General.NotFound {}
class TransactionDetailsNotFound extends General.NotFound {}
class CannotRemoveExternalAccount extends BackendError {}

export default {
    BankAccountDoesNotExist,
    CannotRemoveExternalAccount,
    CannotDeactivateExternalAccount,
    DepositIntentNotFound,
    DictRequestNotFound,
    ExternalAccountDoesNotExist,
    InsufficientBalance,
    DuplicatedBankingOperation,
    LedgerEntryDoesNotExist,
    TransactionDetailsNotFound,
};
